import { call, put, takeLeading, select } from 'redux-saga/effects'
import {
  types,
  IGetPublishedGraphicAction,
  IPublishedGraphic,
} from '../types/publishedGraphic'
import * as actions from '../actions/publishedGraphic'
import { selectGroupById } from '../selectors/groups'
import * as services from '../services/publishedGraphic'
import { trace } from '../services/common'
import { getGroupsSaga } from './groups'

export function* getPublishedGraphicByIdSaga(
  action: IGetPublishedGraphicAction
) {
  try {
    const publishedGraphicData: IPublishedGraphic = yield call(
      services.getPublishedGraphicById,
      action.id
    )
    const groupData = yield select(selectGroupById(publishedGraphicData.group))
    if (!groupData) {
      yield call(getGroupsSaga)
    }
    const { shortTitle: groupTitle } =
      groupData || (yield select(selectGroupById(publishedGraphicData.group)))
    yield put(
      actions.getPublishedGraphicByIdSuccess({
        ...publishedGraphicData,
        groupTitle,
      })
    )
  } catch (err) {
    trace(err)
    yield put(actions.getPublishedGraphicByIdFailure(err.message))
  }
}

export function* publishedGraphicWatcher() {
  yield takeLeading(
    types.GET_PUBLISHED_GRAPHIC_BY_ID__STARTED,
    getPublishedGraphicByIdSaga
  )
}
